<template>
 <div>
   <div class="searchBox" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="110px" size="mini">
         <div class="searchBox inpBox">
            <div class="item">
            <el-form-item label="结算单号:" prop="settlementNo">
              <el-input  placeholder="" v-model="searchFrom.settlementNo"></el-input>
            </el-form-item>
            <!-- <el-form-item label="收款企业:" prop="recvCompany">
              <el-input  placeholder="" v-model="searchFrom.recvCompany"></el-input>
            </el-form-item> -->
             <el-form-item label="船舶名称:" prop="shipName">
              <el-input  placeholder="" v-model="searchFrom.shipName"></el-input>
            </el-form-item>
             <el-form-item label="航次号:" prop="shipDateNo">
              <el-input  placeholder="" v-model="searchFrom.shipDateNo"></el-input>
            </el-form-item>
              <el-form-item label="归属月份:" prop="costBelong1">
                <el-date-picker
                  v-model="searchFrom.costBelong1"
                  type="monthrange"
                  value-format="yyyy-MM"
                  range-separator="至"
                  start-placeholder="开始月份"
                  end-placeholder="结束月份">
                </el-date-picker>
            </el-form-item>
              <el-form-item label="结算状态:" prop="settlementStatus">
                <el-select  v-model="searchFrom.settlementStatus"   placeholder="请选择">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="未结算" value="1"></el-option>
                  <el-option label="已结算" value="2"></el-option>
                </el-select>
              </el-form-item>
            <el-form-item label="创建时间:" prop="createTimes">
                <el-date-picker
                  v-model="searchFrom.createTimes"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
            </div>
        </div>
       <div class="searchBtnBox">
         <el-form-item v-if="btnFlg[0]">
            <el-button type="primary" @click="searchFn">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"  @click="resetForm('searchFrom')">重置</el-button>
          </el-form-item>
          <el-form-item v-if="btnFlg[1]">
            <el-button type="primary"  @click="addRegion">新增</el-button>
          </el-form-item>
          <el-form-item v-if="btnFlg[2]">
            <el-button type="primary"  @click="delFn">删除</el-button>
          </el-form-item>
          <el-form-item v-if="btnFlg[3]">
            <el-button type="primary"  @click="exportFn" :disabled="isDisable">导出</el-button>
          </el-form-item>
           <el-form-item v-if="btnFlg[4]">
            <el-button type="primary"  @click="guishuFN">归属标记</el-button>
          </el-form-item>
           <el-form-item label="总吨数:" prop="">
            <span class="red">{{tongji.totalWeight?tongji.totalWeight.toFixed(3):'0.000'}}吨</span>
          </el-form-item>
          <el-form-item label="实付合计:" >
            <span class="red">{{tongji.allActualPayment?tongji.allActualPayment.toFixed(2):'0.00'}}元</span>
          </el-form-item>
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
       @row-click="handleRowClick"  style="width: 100%" height="100%"  center border>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
         <el-table-column label="操作"  width="170">
            <template slot-scope="scope">
              <div>
                <el-button type="text" size="mini" v-if="btnFlg[5]"   @click="editFn(scope.row)">修改</el-button>
                <el-button type="text" size="mini" v-if="btnFlg[6]"  @click="fukuanFN(scope.row)">付款</el-button>
                <el-button type="text" size="mini" v-if="btnFlg[7]"  @click="fapiaoFN(scope.row)">发票</el-button>
                <el-button type="text" size="mini" v-if="btnFlg[8]"   @click="zhiqihanFn(scope.row)">滞期函</el-button>
              </div>
            </template>
        </el-table-column>
        <el-table-column prop="settlementNo" min-width="220"  :formatter="emptyFn" label="结算单号"></el-table-column>
        <el-table-column prop="shipName" width="160" :formatter="emptyFn" label="船舶名称"></el-table-column>
        <el-table-column prop="shipDateNo" width="200" :show-overflow-tooltip="true" label="航次号"></el-table-column>
        <el-table-column prop="factWeight" width="160" :formatter="emptyFn" label="实际载重(吨)"></el-table-column>
         <el-table-column property="pricingMethod" width="110" label="计价方式" >
          <template scope="scope">
            {{[ "按吨", "包船" ][scope.row.pricingMethod-1]}}
          </template>
        </el-table-column>
        <el-table-column prop="factPrice" width="160" :formatter="emptyFn" label="运价(元)"></el-table-column>
        <el-table-column prop="freightPrice" width="160" :formatter="emptyFn" label="运费金额(元)"></el-table-column>
        <el-table-column prop="demurragePrice" width="160" :formatter="emptyFn" label="滞期费(元)"></el-table-column>
        <el-table-column property="pricingMethod" width="110" label="应付合计(元)" >
          <template scope="scope"> {{scope.row.totalPayable.toFixed(2)}}</template>
        </el-table-column>
        <el-table-column property="pricingMethod" width="110" label="实付合计(元)" >
          <template scope="scope"> {{scope.row.actualPayment.toFixed(2)}}</template>
        </el-table-column>
        <el-table-column property="pricingMethod" width="110" label="实收发票(元)" >
          <template scope="scope"> {{scope.row.receiveInvoice?scope.row.receiveInvoice.toFixed(2):""}}</template>
        </el-table-column>
        <!-- <el-table-column property="pricingMethod" width="110" label="未付合计(元)" >
          <template scope="scope"> {{scope.row.totalUnpaid.toFixed(2)}}</template>
        </el-table-column> -->
        <!-- <el-table-column prop="recvCompany"  min-width="200" :formatter="emptyFn" label="收款企业"></el-table-column> -->
        <el-table-column prop="shipTransportNo" width="240" :formatter="emptyFn" :show-overflow-tooltip="true" label="船运单号"></el-table-column>
         <el-table-column property="settlementStatus" width="110" label="结算状态" >
          <template scope="scope">
            {{[ "未结算", "已结算" ][scope.row.settlementStatus-1]}}
          </template>
        </el-table-column>
        <el-table-column prop="costBelong"  min-width="140" :formatter="(row, column,cellValue,index) => dateTimeFormat(row, column,cellValue,index, 2)" label="归属月份"></el-table-column>
        <el-table-column prop="belongRemark" width="120" :formatter="emptyFn" label="归属备注"></el-table-column>
        <el-table-column prop="signUserName" width="120" :formatter="emptyFn" label="标记人"></el-table-column>
        <el-table-column prop="signTime" width="170" :formatter="dateTimeFormat" label="标记时间"></el-table-column>
        <el-table-column prop="createUserName" width="150" :formatter="emptyFn" label="创建人"></el-table-column>
        <el-table-column prop="createTime" width="170" :formatter="dateTimeFormat"  label="创建时间"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,1000]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 新建修改 -->
    <el-dialog  :title="isAdd?'添加':'修改'"  :close-on-click-modal="false" :close-on-press-escape="false" class="jiaoyan" @close="closeDialog"   :visible.sync="dialogVisible" width="800px" center>
      <span>
         <el-form :inline="true" :rules="rules" :model="addFrom" ref="addFrom" class="demo-form-inline" label-width="130px" size="mini">
        <div class="inpBox">
             <el-form-item label="船运单号:" prop="shipTransportNo" >
                <el-input  placeholder=""   maxlength="50" @blur="shipTransportNoFn" v-model="addFrom.shipTransportNo"  ></el-input>
              </el-form-item>
              <el-form-item label="船舶名称:" prop="shipName">
                <el-input  placeholder=""   maxlength="50" v-model="addFrom.shipName"  ></el-input>
              </el-form-item>
              <el-form-item label="航次号:" prop="shipDateNo" >
                <el-input  placeholder=""   maxlength="50" v-model="addFrom.shipDateNo"  ></el-input>
              </el-form-item>
              <el-form-item label="实际载重:" prop="factWeight" class="jiage">
                <el-input  placeholder=""  v-number-input.float="3"  maxlength="11" v-model="addFrom.factWeight"  ></el-input><span class="danwei1">吨</span>
              </el-form-item>
              <el-form-item label="计价方式:" prop="pricingMethod" class="jiage">
                <el-select  v-model="addFrom.pricingMethod"  placeholder="请选择" >
                  <el-option v-for="val in pricingMethods" :label="val.name" :value="val.val" :key="val.val"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="运价:" class="jiage" prop="factPrice"  >
                <el-input  placeholder=""  v-number-input.float="2"  maxlength="11" v-model="addFrom.factPrice" ></el-input>
                <span class="danwei">{{addFrom.pricingMethod==1?'元/吨':'元'}}</span>
              </el-form-item>
              <el-form-item label="运费金额:" class="jiage" prop="freightPrice"  >
                <el-input  placeholder=""   class="disabled" :readonly="true" v-model="addFrom.freightPrice" ></el-input><span class="danwei">元</span>
              </el-form-item>
              <el-form-item label="滞期费:" class="jiage" prop="demurragePrice"  >
                <el-input  placeholder=""  v-number-input.float="2"  maxlength="11" v-model="addFrom.demurragePrice" ></el-input><span class="danwei">元</span>
              </el-form-item>
              <el-form-item label="应付金额:" class="jiage" prop="totalPayable"  >
                <el-input  placeholder=""   class="disabled" :readonly="true" v-model="addFrom.totalPayable" ></el-input><span class="danwei">元</span>
              </el-form-item>
              <el-form-item label="备注:"  prop="remark" >
                <el-input  placeholder=""   maxlength="20" v-model="addFrom.remark"></el-input>
              </el-form-item>
              <div class="addressBox" v-if="dialogVisible">
                <h4 class="title">
                  <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>滞期函</span>
                </h4>
                <div>
                    <div class="imgBox">
                      <uploadImgs :imgList.sync='imgList' :max=5 @remove='remove'></uploadImgs>
                  </div>
                </div>
              </div>
        </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveFn('addFrom')">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 费用归属标记 -->
    <el-dialog  title="费用归属标记"  :close-on-click-modal="false" :close-on-press-escape="false" class="jiaoyan" @close="closeDialog"   :visible.sync="GSdialog" width="500px" center>
      <span>
         <el-form :inline="true" :rules="rules" :model="GSFrom" ref="GSFrom" class="demo-form-inline" label-width="130px" size="mini">
        <div class="inpBox">
             <el-form-item label="归属月份:" prop="costBelong" >
                <el-date-picker  v-model="GSFrom.costBelong" value-format="timestamp" type="month" placeholder="选择月"> </el-date-picker>
              </el-form-item>
              <el-form-item label="归属备注:"  prop="belongRemark" >
                <el-input  placeholder=""   maxlength="20" v-model="GSFrom.belongRemark"></el-input>
              </el-form-item>
        </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="GSdialog = false">取 消</el-button>
        <el-button type="primary" @click="GSsaveFn('GSFrom')">保存</el-button>
      </span>
    </el-dialog>
     <!-- 滞期函 -->
    <el-dialog  title="滞期函"  :close-on-click-modal="false" :close-on-press-escape="false" class="jiaoyan"    :visible.sync="ZQHdialog" width="1000px" center>
      <span>
        <div class="addressBox">
            <h4 class="title">
              <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>滞期函</span>
            </h4>
            <div class="">
              <el-image
                v-for="(item,index) in zhanshiList" :src="item" :key="index"
                style="width: 290px; height: 200px ; margin-right: 30px;"
                :preview-src-list="getSrcList(index,zhanshiList)">
              </el-image>
          </div>
        </div>
      </span>
       <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="ZQHdialog = false">关闭</el-button>
      </span>
    </el-dialog>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { sShipSettlementList, addOrUpdateSettlement, sShipSettlementDelete, belongSign, shipDateDetail, settlementFile } from '@/api/shipping'
import { emptyFn, dateTimeFormat, dateFormat, toFixed } from '@/utils/util'
import uploadImgs from '@/components/uploadImgs.vue'
import { compressImages } from '@/utils/compressImages'
import { exportExcel } from '@/utils/fileDownXlsx.js'
export default {
  components: {
    uploadImgs
  },
  data () {
    var id = this.$route.query.id
    return {
      id: id,
      h: 500,
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      dialogVisible: false,
      isAdd: true,
      tableList: [],
      tongji: {},
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      total: 0,
      ids: [],
      loading: 'false',
      rules: {
        shipTransportNo: [
          { required: true, message: '请输入船运单号', trigger: 'blur' }
        ],
        shipName: [
          { required: true, message: '请输入船舶名称', trigger: 'blur' }
        ],
        shipDateNo: [
          { required: true, message: '请输入航次号', trigger: 'blur' }
        ],
        factPrice: [
          { required: true, message: '请输入运价', trigger: 'blur' }
        ],
        costBelong: [
          { required: true, message: '请选择归属月份', trigger: 'blur' }
        ]
      },
      addFrom: {
        pricingMethod: 1
      },
      pricingMethods: [
        { val: 1, name: '按吨' },
        { val: 2, name: '包船' }
      ],
      isDisable: false,
      GSdialog: false,
      GSFrom: {},
      imgList: [],
      ZQHdialog: false,
      zhanshiList: [],
      btnFlg: [],
      btnIdArr: ['00KM0C0100', '00KM0C0200', '00KM0C0300', '00KM0C0400', '00KM0C0500',
        '00KM0C0600', '00KM0C0700', '00KM0C0800', '00KM0C0900']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/SshipSettlement')
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 98) + 'px'
    if (this.id) {
      this.addFrom = { pricingMethod: 1 }
      shipDateDetail({ id: this.id }).then(res => {
        this.$set(this.addFrom, 'shipTransportNo', res.shipTransportNo)
        this.$set(this.addFrom, 'shipName', res.shipName)
        this.$set(this.addFrom, 'shipDateNo', res.shipDateNo)
        this.$set(this.addFrom, 'factWeight', res.weight)
        this.$set(this.addFrom, 'factPrice', res.unitPrice)
      })
      this.dialogVisible = true
      this.isAdd = true
    }
  },
  methods: {
    // 付款
    fukuanFN (row) {
      this.$router.push({ name: 'settlementPayment', query: { id: row.id } })
    },
    // 发票
    fapiaoFN (row) {
      this.$router.push({ name: 'settlementInvoice',
        query: {
          id: row.id,
          shipName: row.shipName,
          shipDateNo: row.shipDateNo
        } })
    },
    // 滞期函
    zhiqihanFn (row) {
      this.zhanshiList = []
      settlementFile({ id: row.id, type: 1 }).then(res => {
        if (res.length > 0) {
          res.forEach(item => {
            this.zhanshiList.push(item.fileUrlOSS)
          })
          this.ZQHdialog = true
        } else {
          this.$alert('该结算下面没有滞期函', '系统提示')
        }
      })
    },
    // 点击凭证放大
    getSrcList (index, arr) {
      return arr.slice(index).concat(arr.slice(0, index))
    },
    // 归属标记
    guishuFN () {
      let selectData = this.$refs.table.selection
      if (selectData.length < 1) {
        this.$alert('请选择一条要操作的数据', '系统提示')
        return
      }
      this.GSFrom = {}
      let ids = []
      selectData.forEach(item => {
        ids.push(item.id)
      })
      this.GSdialog = true
      this.GSFrom.ids = ids
    },
    GSsaveFn (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          belongSign(this.GSFrom).then(res => {
            loading.close()
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.GSdialog = false
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        } else {
          return false
        }
      })
    },
    // 导出
    exportFn () {
      let form = { ...this.searchFrom }
      exportExcel(
        this.global.shipping + '/sShipSettlement/exportSettlementList',
        form,
        '海运结算'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 查选
    searchFn () {
      if (this.searchFrom.cargoBarcodes) { this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcodes.split(/[(\r\n)\r\n]+/) }

      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {

    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      let arr = this.searchFrom.costBelong1
      if (arr) {
        this.$set(this.searchFrom, 'costBelong', [arr[0] + '-01', arr[1] + '-01'])
      }
      this.loading = true
      sShipSettlementList(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
        this.tongji = res.map
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 添加
    addRegion () {
      this.addFrom = { pricingMethod: 1 }
      this.dialogVisible = true
      this.isAdd = true
    },
    // 船运单号失去焦点
    shipTransportNoFn () {
      shipDateDetail({ shipTransportNo: this.addFrom.shipTransportNo }).then(res => {
        if (res) {
          this.$set(this.addFrom, 'shipTransportNo', res.shipTransportNo)
          this.$set(this.addFrom, 'shipName', res.shipName)
          this.$set(this.addFrom, 'shipDateNo', res.shipDateNo)
          this.$set(this.addFrom, 'factWeight', res.weight)
          this.$set(this.addFrom, 'factPrice', res.unitPrice)
        } else {
          this.$alert('暂无该船运单据，请检测船运单号是否正确', '系统提示')
        }
      })
    },
    editFn (row) {
      this.addFrom = { ...row }
      this.imgList = []
      this.$set(this.addFrom, 'delFileIds', [])
      settlementFile({ id: row.id, type: 1 }).then(res => {
        if (res.length > 0) {
          res.forEach((item, index) => {
            this.$set(this.imgList, index, { status: 'ready', url: item.fileUrlOSS, id: item.id })
          })
        }
        this.dialogVisible = true
        this.isAdd = false
      })
    },
    // 删除图片
    remove (file) {
      if (file.id) {
        this.addFrom.delFileIds.push(file.id)
      }
    },
    saveFn (formName) {
      let that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let imgfile = new FormData()
          imgfile.set('params', JSON.stringify(this.addFrom))
          let arr = []
          this.imgList.forEach(item => {
            if (!item.id) {
              arr.push(item)
            }
          })
          compressImages(arr, {
            width: 1000
          }).then(result => {
            result.forEach(item => {
              imgfile.append('files', item)
            })
            that.save1(imgfile)
          })
        } else {
          return false
        }
      })
    },
    save1 (data) {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      if (this.id) {
        this.$router.push({ name: 'SshipSettlement' })
      }
      addOrUpdateSettlement(data).then(res => {
        loading.close()
        this.$message({
          message: '操作成功',
          type: 'success'
        })
        this.dialogVisible = false
        this.getList(this.searchFrom)
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    // 删除
    delFn () {
      let selectData = this.$refs.table.selection
      if (selectData.length != 1) {
        this.$alert('请选择一条要操作的数据', '系统提示')
        return
      }
      this.$confirm('是否执行删除操作?', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        sShipSettlementDelete({ id: selectData[0].id }).then(res => {
          loading.close()
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        createTime: null
      }
    },
    closeDialog () {
      this.addFrom = { pricingMethod: 1 }
      this.$refs.table.clearSelection()
      if (this.$refs.addFrom) {
        this.$refs.addFrom.clearValidate()
      }
      this.imgList = []
    }

  },
  watch: {
    addFrom: {
      handler (newName, oldName) {
        let demurragePrice = this.addFrom.demurragePrice ? this.addFrom.demurragePrice : 0
        if (this.addFrom.pricingMethod == 1) {
          if (this.addFrom.factWeight && this.addFrom.factPrice) {
            this.$set(this.addFrom, 'freightPrice', toFixed(accMul(this.addFrom.factWeight, this.addFrom.factPrice), 2))
          } else {
            this.$set(this.addFrom, 'freightPrice', '')
          }
        } else {
          this.$set(this.addFrom, 'freightPrice', this.addFrom.factPrice ? toFixed(this.addFrom.factPrice, 2) : '')
        }
        this.$set(this.addFrom, 'totalPayable', toFixed(Number(demurragePrice) + Number(this.addFrom.freightPrice), 2))
        function accMul (arg1, arg2) {
          var m = 0; var s1 = arg1.toString(); var s2 = arg2.toString()
          try {
            m += s1.split('.')[1].length
          } catch (e) {
          }
          try {
            m += s2.split('.')[1].length
          } catch (e) {
          }

          return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m)
        }
      },
      deep: true
      // immediate: true
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.searchBox .el-date-editor{
      width: 350px!important;
}
.imgBox{
  display: flex;
  .item{
    display: flex;
     width: 50%;
     justify-content: space-around;
  }
}
/deep/ .checkboxBox{
  display: flex;
  label{
    flex-shrink: 0;
  }
  .el-checkbox-group{
    width:250px ;
  }
}
.jiage{
  position: relative;
  .danwei1{
    position: absolute;
    right: 6px;
  }
}
.iconBox {
  position: absolute;
  right: -28px;
  top: 0;
  font-size: 20px;
  color: #0b25d6;
  z-index: 9999;
}
/deep/.el-textarea{
      width: 442px;
}
/deep/.inpBox .el-input__inner{
 width: 180px;
}
.imgBox{
  display: flex;
  flex-direction:column;
}
</style>
